import { render } from "./campaignDetailsSMS.vue?vue&type=template&id=c4dd8ad4&scoped=true"
import script from "./campaignDetailsSMS.vue?vue&type=script&lang=js"
export * from "./campaignDetailsSMS.vue?vue&type=script&lang=js"

import "./campaignDetailsSMS.vue?vue&type=style&index=0&id=c4dd8ad4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4dd8ad4"]])

export default __exports__